export { default as Toast } from "./Toast";
export { ToastProvider, useToast } from "./ToastContext";

// This object provides a global toast API
// To use it in components, import: import { toast } from "path/to/Toast"
// However, this requires the ToastProvider to be mounted in the app
let toastInstance = null;

export const setToastInstance = (instance) => {
  toastInstance = instance;
};

export const toast = {
  success: (message, options) => {
    if (toastInstance) {
      return toastInstance.success(message, options);
    }
    console.warn("Toast not initialized. Wrap your app with ToastProvider.");
  },
  error: (message, options) => {
    if (toastInstance) {
      return toastInstance.error(message, options);
    }
    console.warn("Toast not initialized. Wrap your app with ToastProvider.");
  },
  warning: (message, options) => {
    if (toastInstance) {
      return toastInstance.warning(message, options);
    }
    console.warn("Toast not initialized. Wrap your app with ToastProvider.");
  },
  info: (message, options) => {
    if (toastInstance) {
      return toastInstance.info(message, options);
    }
    console.warn("Toast not initialized. Wrap your app with ToastProvider.");
  },
};
